export {
    MAP_SERVICE_NAME,
    MAP_SERVICE_PROVIDER_NAME,
    MapServiceProvider,
    MapService
} from './services/map.service'

export { MAP_MODULE_NAME } from './map.module'